"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const logo = require('./logo.svg');
const danger = '#d70b0b';
const success = '#87c144';
exports.theme = {
    name: 'lifeCycle',
    userFriendlyName: 'Lifecycle',
    space: [0, 4, 8, 16, 32, 64, 128],
    breakpoints: ['40em', '52em', '64em', '80em', '100em'],
    shadows: [
        '0 1px 2px rgba(125,125,125,0.05)',
        '0 2px 4px rgba(125,125,125,0.1)',
        '0 3px 8px rgba(125,125,125,0.2)',
        '0 4px 16px rgba(125,125,125,0.4)',
        '0 5px 32px rgba(125,125,125,0.6)',
    ],
    fontSizes: {
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        '2xl': '24px',
        '3xl': '28px',
        '4xl': '36px',
        '5xl': '48px',
        '6xl': '64px',
    },
    fontImports: ["@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900')"],
    fonts: {
        heading: 'Roboto',
        subheading: 'Roboto',
        body: 'Roboto',
        navigation: 'Roboto',
    },
    dark: true,
    colors: {
        primary: '#333',
        primaryText: '#fff',
        primaryDark: '#111',
        danger,
        muted: '#ccc',
        success,
        info: 'rgb(70, 120, 200)',
        selected: 'rgb(70, 120, 200)',
        warning: '#FDD835',
        accent: '#87c144',
        online: '#87c144',
        accentBackgroundedText: '#fff',
        pageBackground: '#f6f6f6',
        pageText: '#111',
        cardBackground: '#fff',
        cardText: '#111',
        offline: danger,
        charts: {
            primary: '#87c144',
            min: '#0000ff',
            max: '#ff0000',
            neutral: '#bbbbbb',
            intervalShade: '#ddd',
            grid: 'rgba(125,125,125,0.2)',
            axisTicks: 'rgba(125,125,125,0.2)',
            axisLine: 'rgba(125,125,125,0.2)',
            series: ['#5ab9ea', '#5680e9', '#84ceeb', '#c1c8e4', '#8860d0'],
        },
        install: {
            connected: success,
            expired: danger,
            pending: 'rgb(70, 120, 200)',
            planned: '#555',
            skipped: '#fb0',
        },
        floorplans: {
            furniture: {
                background: '#ddd',
                border: '#ddd',
                desk: {
                    background: '#ccc',
                    border: '#ccc',
                },
            },
            area: {
                background: '#fff',
                border: '#777',
                group: {
                    background: 'transparent',
                    border: 'transparent',
                },
            },
            fixture: {
                background: '#777',
                border: '#777',
                wall: {
                    background: '#000',
                    border: '#000',
                },
                column: {
                    background: '#444',
                    border: '#444',
                },
                door: {
                    background: '#000',
                    border: '#000',
                },
            },
        },
    },
    logo: logo.default,
};
//# sourceMappingURL=index.js.map